async function fetchMaticPrice() {
  try {
    let apiurl = "https://api.binance.us/api/v3/ticker/price?symbol=MATICUSDT";
    let res = await fetchprice(apiurl);
    return res;
  } catch (error) {
    let msg = error.message.toString();
    if (msg.includes("has been blocked by CORS policy") || msg.includes("ERR_FAILED 403 (Forbidden)") || msg.includes("Failed to fetch")) {
      let apiurl = "https://api.binance.com/api/v3/ticker/price?symbol=MATICUSDT";
      let res = await fetchprice(apiurl);
      return res;
    }
    console.log(error);
  }
}
async function fetchprice(apiurl) {
  const response = await fetch(apiurl);
  const data = await response.json();
  console.log(data);
  return parseFloat(data.price);
}
export default fetchMaticPrice;
